import { createContext, useContext } from "react";

// Shares similar-answers state (contributions, loading, review status, callbacks) with
// SimilarAnswersSuggestionsBox and the prompt sub-components without prop-drilling.
export const SimilarAnswersContext = createContext();

// Consumer hook — call this inside any child of SimilarAnswersSuggestions to access the
// shared state without needing explicit props.
export const useSimilarAnswersContext = () => {
  return useContext(SimilarAnswersContext);
};
